// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"15c637b9","188":"0e5d4d6f","601":"808489a2","738":"721ca375","817":"cf5d6fac","892":"4caa2979"}[chunkId] + ".chunk.css";
};